export const InitialData = {
  isRecording: false,
  autoSubmit: false,
  audioSrc: "",
  audioType: "",
  audioFile: null,
  audioDuration: 0,
  recordingTime: 0,
};
